import { InputHTMLAttributes, RefObject } from 'react';
import styled from '@benzinga/themetron';

type DynamicWidthInputProps = {
  ref: RefObject<HTMLInputElement>;
  width: string;
} & InputHTMLAttributes<HTMLInputElement>;

const DynamicWidthInput = styled.input<DynamicWidthInputProps>`
  width: ${({ width }) => width};
`;

DynamicWidthInput.displayName = 'DynamicWidthInput';

export { DynamicWidthInput };
